import React from "react"
import {connect} from "react-redux";
import BrowseView from "../../browse/BrowseView";
import {Row, Col, Button} from "antd"
import {NavLink} from "react-router-dom"
import {bindActionCreators} from "redux"
import * as ImportStatisticsActions from "../../reducers/import";
import PropTypes from "prop-types";
import ImportStatisticsTable from "./ImportStatisticsTable";

class ImportView extends React.Component {
    static propTypes = {
        importStatistics: PropTypes.array.isRequired,
        fetchingImportStatistics: PropTypes.bool.isRequired,
        search: PropTypes.func.isRequired
    };
    state = {
        selectedRowKeys: []
    };


    render() {
        const {getImportStatistics, importStatistics, fetchingImportStatistics, search} = this.props;
        const {selectedRowKeys} = this.state;
        const selectedId = selectedRowKeys[0];
        const disabled = selectedRowKeys.length === 0;
        const titleBar = <Row>
            <Col span={4}>Import Statistics</Col>
            <Col span={1} offset={19}>
                <NavLink to={`/import/${selectedId}`}>
                    <Button type='primary' disabled={disabled}>Open</Button>
                </NavLink>
            </Col>
        </Row>
        return <BrowseView
            masterTitle={titleBar}
            master={<ImportStatisticsTable dataSource={importStatistics} onSelectChange={this.onSelectChange}
                                    loading={fetchingImportStatistics} compact={false}/>}
            initialQuery={getImportStatistics}
            loading={fetchingImportStatistics}
            searchableProps={["type"]}
            searchLogic={search}
        />
    }
}


const mapStateToProps = state => ({
    importStatistics: state.importStatistics.importStatistics,
    fetchingImportStatistics: state.importStatistics.fetchingImportStatistics
});

const mapDispatchToProps = dispatch => ({
    getImportStatistics: bindActionCreators(ImportStatisticsActions, dispatch).getImportStatistics,
    search: bindActionCreators(ImportStatisticsActions, dispatch).search

});
export default connect(mapStateToProps, mapDispatchToProps)(ImportView)



// WEBPACK FOOTER //
// ./src/js/browse/import/statistics.js